import { render, staticRenderFns } from "./addApproval.vue?vue&type=template&id=d6478078&scoped=true&lang=pug"
import script from "./addApproval.vue?vue&type=script&lang=js"
export * from "./addApproval.vue?vue&type=script&lang=js"
import style0 from "./addApproval.vue?vue&type=style&index=0&id=d6478078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6478078",
  null
  
)

export default component.exports